import { IVehicleKBBReport } from "../../ts/kbb.interface";

const KbbReportViewComponent = (vehicle: any) => {
  const kbbData: IVehicleKBBReport = vehicle.vehicle?.kbb_report;
  const vehicleData = vehicle.vehicle;
  const vehicleColor =
    vehicleData?.exterior_color.slice(0, 1).toUpperCase() +
    vehicleData?.exterior_color.slice(-61);

  const equipmentsArray: any[] = [];
  const vehicleOptionIds: number[] = kbbData?.vehicleOptionIds.map(
    (v: string) => +v
  );
  const vehicleOptionsArray = kbbData?.vehicleOptions.filter((val: any) => {
    if (vehicleOptionIds.includes(val.vehicleOptionId)) {
      if (val.optionType === "Equipment") {
        equipmentsArray.push(val);
        return false;
      }
      return true;
    }
    return false;
  });

  const vehicleInfo =
    vehicleData?.year?.toString() +
    " " +
    kbbData?.options?.makeName +
    " " +
    kbbData?.options?.modelPlusTrimName;

  const lendingValue =
    kbbData?.values?.prices?.[0]?.configuredValue?.toFixed(2);
  const adjustedLendingValue =
    lendingValue - kbbData?.values?.prices?.[0]?.mileageAdjustment;

  const retailValue = kbbData?.values?.prices?.[1]?.configuredValue?.toFixed(2);
  const adjustedRetailValue =
    retailValue - kbbData?.values?.prices?.[1]?.mileageAdjustment;

  const mileageAdjustment = kbbData?.values?.prices?.[0]?.mileageAdjustment;

  const kbbReportUpdatedAt = new Date(+kbbData?.updated_at * 1000);
  const printedAt = kbbReportUpdatedAt.toLocaleDateString("en-gb");

  return (
    <div>
      <div className="flex justify-between items-start">
        <div>
          <div className="text-xl font-semibold">Spectrum Financial</div>
          <div>Lending/Suggested Retail Breakdown</div>
        </div>
        <div className="text-sm">Printed on: {printedAt || "--"}</div>
      </div>
      <div className="flex justify-between items-start mt-8 mb-2">
        <div>
          <div className="font-bold">VIN: {vehicleData?.vin || "--"}</div>
          <div className="text-sm">License Plate #: --</div>
        </div>
        <div>
          <div className="text-sm font-bold">
            Stock #: {vehicleData?.stock_number || "--"}
          </div>
          {vehicleData.auction_vehicle ? (
            <div className="text-sm">
              Lane: {vehicleData.auction_vehicle[0].lane} | Run:{" "}
              {vehicleData.auction_vehicle[0].run}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="flex justify-between border-t-4 border-b-2 py-2 border-tertiary-300 font-semibold">
        <div>Vehicle Info</div>
        <div>Lending/Retail</div>
      </div>
      <div className="text-sm">
        <div className="flex justify-between my-1">
          <div>{vehicleInfo}</div>
          <div>
            ${" " + adjustedLendingValue} / ${" " + adjustedRetailValue}
          </div>
        </div>
        {equipmentsArray.length > 0 &&
          equipmentsArray.map((data: any) => (
            <div
              className="flex justify-between my-1"
              key={data?.vehicleOptionId}
            >
              <div>{data.optionName}</div>
              <div>Included/Included</div>
            </div>
          ))}
        <div className="flex justify-between my-1">
          <div>{vehicleColor}</div>
          <div>Included/Included</div>
        </div>
      </div>
      <div className="flex justify-between border-t-2 border-b-2 py-2 border-tertiary-300 font-semibold">
        <div className="w-1/2 flex justify-between mr-1">
          <div>Equipment</div>
          <div>Option Value</div>
        </div>
        <div className="w-1/2 flex justify-between ml-1">
          <div>Equipment</div>
          <div>Option Value</div>
        </div>
      </div>
      <div className="flex justify-between text-sm">
        <div className="w-1/2 mr-1">
          {vehicleOptionsArray
            .slice(0, Math.floor(vehicleOptionsArray.length / 2))
            ?.map((option: any) => {
              return (
                <div
                  className="flex justify-between my-1"
                  key={option?.vehicleOptionId}
                >
                  <div>{option.optionName}</div>
                  <div>Included/Included</div>
                </div>
              );
            })}
        </div>
        <div className="w-1/2 ml-1">
          {vehicleOptionsArray
            .slice(Math.floor(vehicleOptionsArray.length / 2))
            ?.map((option: any) => {
              return (
                <div
                  className="flex justify-between my-1"
                  key={option?.vehicleOptionId}
                >
                  <div>{option.optionName}</div>
                  <div>Included/Included</div>
                </div>
              );
            })}
        </div>
      </div>
      <div className=" border-t-2 border-b-2 py-2 border-tertiary-300">
        <div className="flex justify-between my-1">
          <div>Lending/Retail Value</div>
          <div>
            ${" " + adjustedLendingValue} / ${" " + adjustedRetailValue}
          </div>
        </div>
        <div className="flex justify-between my-1">
          <div>Mileage Adjustments ({vehicleData?.mileage || "--"})</div>
          <div>${" " + mileageAdjustment}</div>
        </div>
      </div>
      <div className="flex justify-between border-b-4 py-2 border-tertiary-300 font-semibold">
        <div>Kelley Blue Book Lending/Retail Value</div>
        <div>
          ${" " + lendingValue} / ${" " + retailValue}
        </div>
      </div>
    </div>
  );
};

export default KbbReportViewComponent;
